import { observer } from 'mobx-react-lite'
import { StepsCommonLayout } from 'pages/settings/ui/StepsCommonLayout/StepsCommonLayout'
import {
  CallingStepsProvider,
  useCallingStepsContext,
} from 'pages/settings/pages/compliance/pages/calling/context/callingStepsContext'
import { useComplianceLayerContext } from 'pages/settings/pages/compliance/context'
import { useProgressInfoTitle } from 'pages/settings/pages/compliance/pages/calling/hooks/useProgressInfoTitle'
import { useLayoutTitle } from 'pages/settings/pages/compliance/pages/calling/hooks/useLayoutTitle'
import { type CallingRoutesSteps } from 'pages/settings/pages/compliance/pages/calling/route/type'

export const CallingLayoutContent = observer(() => {
  const {
    stepsStore: { step, totalSteps },
    closeSetting,
    decreaseStep,
  } = useCallingStepsContext()

  return (
    <StepsCommonLayout
      progressTitle={useProgressInfoTitle()}
      totalSteps={totalSteps}
      title={useLayoutTitle()}
      settingsStep={step}
      closeSetting={closeSetting}
      decreaseStep={(lastPathSegment) => decreaseStep(lastPathSegment as CallingRoutesSteps)}
    />
  )
})

export const CallingStepsLayout = () => {
  const complianceLayerStore = useComplianceLayerContext()

  return (
    <CallingStepsProvider complianceLayerStore={complianceLayerStore}>
      <CallingLayoutContent />
    </CallingStepsProvider>
  )
}
